<template>
  <div id="dashboardTV">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <TrailReportsTV />
        </div><!-- /.col-md-8 -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div><!-- /#dashboard -->
</template>

<script>
import TrailReportsTV from './TrailReportsTV'
import { mapState } from 'vuex'

export default {
  components: {
    TrailReportsTV
  },
  computed: {
    ...mapState(['dashboard'])
  },
  mounted() {
    this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: true})
    if (this.$route.params.pane) {
      this.$store.commit('changePanel', this.$route.params.pane)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tv/DashboardTV.vue